import * as React from "react";
import { fetchAsset } from "../CourierService/FetchService";
import { themeOn, ux_plugin_url } from "../config/apiConfig";
import { useFormDispatch } from "../components/main/ActivationForm/Context/ActivationFormContext";

const ThemeLoader: React.FC<{
  onLogoSrc: (logo: string) => void;
}> = ({ onLogoSrc }) => {
  const dispatch = useFormDispatch();

  React.useEffect(() => {
    if (ux_plugin_url === "") {
      revealLogo();
      return;
    }

    const favicon =
      document.querySelector("link[rel*='icon']") ||
      document.createElement("link");
    const logo = document.querySelector<HTMLImageElement>(".oLogo > img");
    const waitingBanner = document.querySelector<HTMLImageElement>(
      ".waitingRoomLoadingHeroImage > img"
    );
    const loadingBanner = document.querySelector<HTMLImageElement>(
      ".loadingRoomLoadingHeroImage > img"
    );

    fetchAsset("ux-config.json")
      .then(async (res) => {
        if (res.status !== 200) return;
        const uxConfig = await res.json();

        const defaultThemeId = uxConfig?.realmDefaultTheme;
        const themes = uxConfig?.themes || [];
        const theme = themes.find((t: any) => t.id === defaultThemeId);
        if (!theme) return;

        // set theme colors
        const colorVars = theme.styles?.colors || {};
        const ThemeColorMap: Record<string, string | undefined> = {
          "--html-txt-color": colorVars.fgBase,
          "--link-color": colorVars.primaryBase,
          "--link-hover-color": colorVars.primaryDarker,
          "--header-color": colorVars.fgBase,
          "--header-base-color": colorVars.chBgBase,
          "--main-base-white": colorVars.white,
          "--main-base-color": colorVars.bgDarker,
          "--main-side-color": colorVars.bgLight,
          "--main-form-color": colorVars.fgDark,
          "--main-button-bg-color": colorVars.primaryDark,
          "--main-button-bg-color-disabled": colorVars.primaryLighter,
          "--blockquote-color": colorVars.fgLighter,
          "--blockquote-border-color": colorVars.fgLighter,
          "--selection-bg-color": colorVars.primaryBase,
          "--selection-color": colorVars.white,
          "--table-text-color": colorVars.fgBase,
          "--table-border-color": colorVars.bgDarkest,
          "--pre-color": colorVars.fgLight,
          "--pre-border-color": colorVars.bgDarkest,
          "--pre-bg-color": colorVars.bgLightest,
          "--db-link-color": colorVars.primaryBase,
          "--link-visited": colorVars.primaryBase,
          "--main-bg-success": "#508223",
          "--main-bg-warning": "#AC630C",
          "--main-bg-danger": "#D63B25",
          "--main-bg-info": "#00688C",
          "--main-bg-freeTier": "#7405CE",
          "--main-bg-warningBanner": "#ff0",
          "--main-bg-slateGray": "#697778",
          "--main-bg-tertiaryBgLnk": "#007ccb",
        };

        for (const [key, val] of Object.entries(ThemeColorMap)) {
          if (val) document.documentElement.style.setProperty(key, val);
        }

        // set favicon
        if (favicon && uxConfig.commonAssets?.favicon) {
          favicon.setAttribute(
            "href",
            ux_plugin_url + uxConfig.commonAssets.favicon
          );
          favicon.setAttribute("rel", "icon");
          document.head.appendChild(favicon);
        }

        // set banner logo and emit logo value
        const logoAsset = theme.assets?.logo;
        if (logoAsset) {
          const logoUrl = logoAsset.includes("themes")
            ? `${ux_plugin_url}${logoAsset}`
            : `${ux_plugin_url}themes/${defaultThemeId}/${logoAsset}`;

          logo?.setAttribute("src", logoUrl);
          waitingBanner?.setAttribute("src", logoUrl);
          loadingBanner?.setAttribute("src", logoUrl);

          onLogoSrc(logoUrl);
        }

        // page title
        const pageTitle =
          themeOn && uxConfig.pageconfig?.title
            ? uxConfig.pageconfig.title
            : "Acme Corp";

        document.title = pageTitle;
        dispatch({
          type: "UPDATE_COMPANY_NAME",
          payload: pageTitle,
        });
      })
      .catch(console.error)
      .finally(revealLogo);
  }, [onLogoSrc, dispatch]);

  return <></>;
};

const revealLogo = () => {
  const logo = document.querySelector(".oLogo > img");
  logo?.parentElement?.removeAttribute("hidden");
};

export default ThemeLoader;
